import axios from 'axios';
import { toast } from 'react-toastify';

import { ROOT_URL } from '../../actions';

export const FETCH_SUMMARY = 'fetch_summary';
export const FETCH_SUMMARY_SUCCESS = 'fetch_summary_success';
export const FETCH_SUMMARY_ERROR = 'fetch_summary_error';

export const CREATE_SUMMARY = 'create_summary';
export const CREATE_SUMMARY_SUCCESS = 'create_summary_success';
export const CREATE_SUMMARY_ERROR = 'create_summary_error';

export const FETCH_AUTO_SUMMARY = 'fetch_auto_summary';
export const FETCH_AUTO_SUMMARY_SUCCESS = 'fetch_auto_summary_success';
export const FETCH_AUTO_SUMMARY_ERROR = 'fetch_auto_summary_error';

export const UPDATE_SUMMARY = 'update_summary';
export const UPDATE_SUMMARY_SUCCESS = 'update_summary_success';
export const UPDATE_SUMMARY_ERROR = 'update_summary_error';


axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');

export function fetchSummary(id) {
  const request = axios.get(`${ROOT_URL}/brands-summaries?brand=${id}`);
  return (dispatch) => {
    dispatch({ type: FETCH_SUMMARY });
    request.then((data) => {
      dispatch({ type: FETCH_SUMMARY_SUCCESS, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_SUMMARY_ERROR, error });
    });
  };
}

export function createSummary(values) {
  const request = axios.post(`${ROOT_URL}/brands-summaries`, values);
  return (dispatch) => {
    dispatch({ type: CREATE_SUMMARY });
    request.then((data) => {
      dispatch({ type: CREATE_SUMMARY_SUCCESS, payload: data });
      toast.success('Summary Saved');
    }).catch((error) => {
      dispatch({ type: CREATE_SUMMARY_ERROR, error });
    });
  };
}

export function updateSummary(id, values) {
  const request = axios.patch(`${ROOT_URL}/brands-summaries/${id}/`, values);
  return (dispatch) => {
    dispatch({ type: UPDATE_SUMMARY });
    request.then((data) => {
      dispatch({ type: UPDATE_SUMMARY_SUCCESS, payload: data });
      toast.success('Summary Saved');
    }).catch((error) => {
      dispatch({ type: UPDATE_SUMMARY_ERROR, error });
    });
  };
}

export function fetchAutoSummary(id) {
  const request = axios.get(`${ROOT_URL}/brands-summaries?brand=${id}&system_generated=true`);
  return (dispatch) => {
    dispatch({ type: FETCH_AUTO_SUMMARY });
    request.then((data) => {
      dispatch({ type: FETCH_AUTO_SUMMARY_SUCCESS, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_AUTO_SUMMARY_ERROR, error });
    });
  };
}

export function deleteSummary(id) {
  const request = axios.delete(`${ROOT_URL}/brands-summaries?brand=${id}`);
  request.then((data) => {
    console.log('deleted sumamries in', id);
    console.log(data);
  }).catch((error) => {
    console.log('error deleting ', id, error);
  });
}



// WEBPACK FOOTER //
// ./src/actions/summary/index.js